import uniqBy from "./component-library227.mjs";
import { getGoliathImages } from "@i22/rocket";
const getImagesFromOffer = (offer) => {
  var _a;
  if (!offer)
    return [];
  const baseImages = [];
  if ("media" in offer && offer.media) {
    offer.media.forEach((media) => {
      if (media && media.remote === false) {
        baseImages.push(media);
      }
    });
  }
  if (baseImages.length === 0 && offer.product && "teaserImage" in offer.product && !((_a = offer.product.teaserImage) == null ? void 0 : _a.remote)) {
    baseImages.push(offer.product.teaserImage);
  }
  const product = offer == null ? void 0 : offer.product;
  const bundledProducts = product && "bundledProducts" in product ? product.bundledProducts || [] : [];
  const additionalImages = bundledProducts.map((i) => i == null ? void 0 : i.teaserImage);
  const uniqueAdditionalImages = uniqBy(additionalImages, "path");
  return getGoliathImages({
    // @ts-ignore
    media: [...baseImages, ...uniqueAdditionalImages]
  });
};
const getMainImageFromOffer = (offer, index = 0) => {
  if (!offer)
    return void 0;
  const offerImages = getImagesFromOffer(offer);
  if (offerImages.length < index + 1)
    return void 0;
  return offerImages[index];
};
export {
  getImagesFromOffer,
  getMainImageFromOffer
};
